<template>
  <v-card>
    <v-card-title>
      Customers

      <div class="flex-grow-1"></div>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filter"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-card-text>
        <v-data-table
          v-if="customers"
          :headers="propHeaders"
          :items="customers"
          :search="search"
          class="elevation-1"
          @click:row="rowClicked">
        </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'CustomersTable',

  props: ['propSearch', 'propHeaders'],

  data: () => ({
    search: ''
  }),

  methods: {
    rowClicked (customer) {
      console.log('rowClicked customer.id:', customer.id)
      this.$router.push('/customer/' + customer.id)
    }
  },

  computed: {
    customers () {
      return this.$store.state.customers
    }
  }
}
</script>
